import add from '@iconify/icons-ic/add';
import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  InputAdornment,
  Grid,
  Autocomplete,
  TextField
} from '@mui/material';
import { BiCloudDownload, BiCloudUpload } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { useDispatch } from 'react-redux';
import { RootStyle, SearchStyle } from '../Global/Styling';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import { getBankDropdownData } from '../../store/Slice/Global/GlobalSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

export default function PayoutToolbar({
  parent,
  selectStatus,
  setSelectStatus,
  filterName,
  onFilterName,
  filterParameter,
  setFilterParameter,
  handleDownload,
  typeIdValue
}) {
  const [isOpenFilter, setOpenFilter] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { LoginData } = useLoginSelector();
  const { MasterTypeListDrop, BankDrop, CityDrop, LoanTypeDrop } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setSelectStatus(' ');

    setFilterParameter((pre) => ({
      bankId: null,
      cityId: null,
      loanTypeId: null
    }));
  };

  const getBankDropApi = useCallback(() => {
    if (!LoginData) return;
    const data = { companyId: LoginData?.companyId, userId: LoginData?.userId };
    dispatch(getBankDropdownData(data));
  }, [LoginData]);

  useEffect(() => {
    getBankDropApi();
  }, [getBankDropApi]);

  return (
    <>
      {isOpenFilter && (
        <Box
          sx={{
            p: 2.5,
            bgcolor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0'
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <Select
                fullWidth
                size="small"
                value={filterParameter?.loanTypeId || ' '}
                onChange={(e) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    loanTypeId: e.target?.value
                  }));
                }}
                sx={{
                  bgcolor: '#fff',
                  borderRadius: '8px',
                  fontSize: 13,
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' }
                }}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>
                {LoanTypeDrop?.length > 0 &&
                  LoanTypeDrop?.map((item) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="combo-box-bank"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option.label || ''}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Select Bank"
                    sx={{
                      bgcolor: '#fff',
                      borderRadius: '8px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        fontSize: 13
                      },
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' }
                    }}
                  />
                )}
                value={BankDrop?.find((item) => item.value === filterParameter?.bankName) || null}
                onChange={(e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Select
                fullWidth
                size="small"
                value={filterParameter?.cityId || ' '}
                onChange={(e) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    cityId: e.target?.value
                  }));
                }}
                sx={{
                  bgcolor: '#fff',
                  borderRadius: '8px',
                  fontSize: 13,
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' }
                }}
              >
                <MenuItem value=" " disabled>
                  Select City
                </MenuItem>
                {CityDrop?.length > 0 &&
                  CityDrop?.map((item) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Reset Filter">
                <IconButton
                  onClick={(e) => handleRemoveFilter(e)}
                  size="small"
                  sx={{
                    bgcolor: 'rgba(239, 68, 68, 0.08)',
                    color: '#ef4444',
                    borderRadius: '8px',
                    p: 1,
                    '&:hover': { bgcolor: 'rgba(239, 68, 68, 0.16)' }
                  }}
                >
                  <FilterListOffIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}
      <RootStyle
        sx={{
          minHeight: 56,
          px: 2.5,
          borderBottom: '1px solid #e2e8f0',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="Add New File" placement="top" arrow>
            <IconButton
              onClick={() => navigate(`/${parent}/add`)}
              sx={{
                bgcolor: '#13519d',
                color: '#fff',
                borderRadius: '8px',
                width: 36,
                height: 36,
                '&:hover': { bgcolor: '#0d3b75' }
              }}
            >
              <Icon icon={add} width={20} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Upload" placement="top" arrow>
            <IconButton
              onClick={() => navigate(`/${parent}/upload`)}
              sx={{
                bgcolor: 'rgba(19, 81, 157, 0.08)',
                color: '#13519d',
                borderRadius: '8px',
                width: 36,
                height: 36,
                '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
              }}
            >
              <BiCloudUpload size={20} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download" placement="top" arrow>
            <IconButton
              onClick={() => handleDownload(typeIdValue)}
              sx={{
                bgcolor: 'rgba(19, 81, 157, 0.08)',
                color: '#13519d',
                borderRadius: '8px',
                width: 36,
                height: 36,
                '&:hover': { bgcolor: 'rgba(19, 81, 157, 0.16)' }
              }}
            >
              <BiCloudDownload size={20} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Payout..."
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            sx={{
              borderRadius: '8px',
              height: 38,
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' }
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: '#94a3b8' }} />
              </InputAdornment>
            }
          />
          <Tooltip title="Filter list">
            <IconButton
              onClick={() => setOpenFilter(!isOpenFilter)}
              sx={{
                bgcolor: isOpenFilter ? '#13519d' : 'rgba(19, 81, 157, 0.08)',
                color: isOpenFilter ? '#fff' : '#13519d',
                borderRadius: '8px',
                width: 36,
                height: 36,
                '&:hover': {
                  bgcolor: isOpenFilter ? '#0d3b75' : 'rgba(19, 81, 157, 0.16)'
                }
              }}
            >
              <Icon icon={roundFilterList} width={20} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
